export default "__VITE_ASSET__DXDGKqRk__"